
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import styled from "styled-components";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  &&& {
    min-width: 132px;
    background: linear-gradient(0deg, #005AA9 0%, rgba(0, 90, 169, 0.85) 100%);
    border-radius: 10px;
    height: 36px;
    margin-bottom: 20px;
    margin-right: 55px;
  }
`;

const StyledSecondaryButton = styled(SecondaryButton)`
  &&& {
    min-width: 132px;
    background: #F7F7F7;
    border-radius: 10px;
    height: 36px;
    color: #005AA9;
    border-width: 0.5px 0.5px 1px 0.5px;
    border-style: solid;
    border-color: #E1E1E1;
    margin-bottom: 20px;
    margin-right: 10px;
    text-transform: none;
  }
`;

const SimpleConfirmDialog = ({ title, message, secondaryContent, modalOpen, handleNo, handleYes, noText, yesText, maxWidth, excludeNoText }) => (
  <Dialog
    fullWidth
    maxWidth={maxWidth}
    open={modalOpen}
    onClose={handleNo}
    id={"confirmDialog"}
    PaperProps={{
      style: {
        borderRadius: "12px"
      }
    }}
  >
    <DialogTitle>{title}</DialogTitle>
    <StyledDialogIconButton onClick={handleNo}>
      <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
    </StyledDialogIconButton>
    <StyledDialogContent>
      <DialogContentText>{message}</DialogContentText>
      <DialogContentText>{secondaryContent}</DialogContentText>
    </StyledDialogContent>
    <DialogActions>
      {!excludeNoText && (
        <StyledSecondaryButton id={"dialogNo"} onClick={handleNo}>
          {noText}
        </StyledSecondaryButton>
      )}
      <StyledPrimaryButton id="dialogYes" onClick={handleYes}>
        {yesText}
      </StyledPrimaryButton>
    </DialogActions>
  </Dialog>
);

export default SimpleConfirmDialog;
